export enum AuthStatus {
  LoggedIn,
  Guest,
}

export interface LoggedInState {
  status: AuthStatus.LoggedIn;
  sid: AuthSID;
}

export interface GuestState {
  status: AuthStatus.Guest;
}

export type AuthState = LoggedInState | GuestState;
